import { configureStore, getDefaultMiddleware } from "@reduxjs/toolkit";
import { loginAPI } from "src/api/loginAPI";
import { homeAPI } from "src/api/homeAPI";
import HomeReducer from "src/store/reducers/homeReduce";
import UserReducer from "src/store/reducers/userReduce";
import AsReducer from "src/store/reducers/asReduce";
import asDetailReduce from "./reducers/asDetailReduce";
import EstimateReducer from "src/store/reducers/estimateReduce";
import noticeReduce from "src/store/reducers/noticeReduce";
import modifyReduce from "src/store/reducers/modifyReduce";
import toogleReduce from "src/store/reducers/toggleReduce";
import redeemReduce from "src/store/reducers/redeemReduce";
import { asAPI } from "src/api/asAPI";
import { userAPI } from "src/api/userAPI";
import { estimateAPI } from "src/api/estimateAPI";
import { manageAPI } from "src/api/manageAPI";
import { scheduleAPI } from "src/api/scheduleAPI";
import { reportAPI } from "src/api/reportAPI";
import { alarmAPI } from "src/api/alarmAPI";
import { skuAPI } from "src/api/skuAPI";
import { bannerAPI } from "src/api/bannerAPI";
import { noticeAPI } from "src/api/noticeAPI";
import fileReduce from "./reducers/fileReduce";
import noticeListReduce from "./reducers/noticeListReduce";
import fulfillDetailReduce from "./reducers/fulfillDetailReduce";
import { fulfillAPI } from "src/api/fulfillAPI";
import fulfillListReduce from "./reducers/fulfillListReduce";
import { redeemAPI } from "src/api/redeemAPI";
import redeemDetailReduce from "./reducers/redeemDetailReduce";
import noticeDetailReduce from "./reducers/noticeDetailReduce";

export const store = configureStore({
  reducer: {
    userReduce: UserReducer,
    homeReduce: HomeReducer,
    asReduce: AsReducer,
    asDetailReduce: asDetailReduce,
    noticeDetailReduce: noticeDetailReduce,
    estimateReduce: EstimateReducer,
    noticeReduce: noticeReduce,
    redeemReduce: redeemReduce,
    modifyReduce: modifyReduce,
    fileReduce: fileReduce,
    toogleReduce: toogleReduce,
    noticeListReduce: noticeListReduce,
    fulfillListReduce: fulfillListReduce,
    fulfillDetailReduce: fulfillDetailReduce,
    redeemDetailReduce: redeemDetailReduce,
    [loginAPI.reducerPath]: loginAPI.reducer,
    [homeAPI.reducerPath]: homeAPI.reducer,
    [asAPI.reducerPath]: asAPI.reducer,
    [userAPI.reducerPath]: userAPI.reducer,
    [estimateAPI.reducerPath]: estimateAPI.reducer,
    [manageAPI.reducerPath]: manageAPI.reducer,
    [scheduleAPI.reducerPath]: scheduleAPI.reducer,
    [reportAPI.reducerPath]: reportAPI.reducer,
    [alarmAPI.reducerPath]: alarmAPI.reducer,
    [skuAPI.reducerPath]: skuAPI.reducer,
    [bannerAPI.reducerPath]: bannerAPI.reducer,
    [noticeAPI.reducerPath]: noticeAPI.reducer,
    [fulfillAPI.reducerPath]: fulfillAPI.reducer,
    [redeemAPI.reducerPath]: redeemAPI.reducer,
  },
  // enhancers: (getDefaultFormatCodeSettings) => getDefaultFormatCodeSettings.concat(),
  // middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(),
  // middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
  // 이벤트 직렬화에 에러 해결
  // A non-serializable value was detected in an action, in the path: `payload.event`. Value
  middleware: getDefaultMiddleware({ serializableCheck: false }),
  //   middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat([asAPI.middleware, asCountAPI.middleware]),
});
// 초기값 정재
export type RootState = ReturnType<typeof store.getState>;
// dispatch()를 사용하면 HTML 안에서 reducer함수를 동작
export type AppDispatch = typeof store.dispatch;
